import StoreContentPage from '../components/content/StoreContentPage';

export default function CookiePolicy() {
  return (
    <StoreContentPage
      contentKey="cookies"
      title="Cookie Policy"
      fallback={
        <>
          <h1 className="font-display" style={{ margin: 0, fontSize: 'clamp(2rem,4vw,3.25rem)' }}>Cookie Policy</h1>
          <p style={{ marginTop: '1rem', opacity: 0.78, lineHeight: 1.75 }}>
            We use essential cookies for storefront functionality (cart, session, security), and optional cookies for
            analytics and experience improvements where enabled by your consent settings.
          </p>
          <p style={{ opacity: 0.78, lineHeight: 1.75 }}>
            You can manage cookie preferences via your browser settings or consent controls shown in supported regions.
          </p>
        </>
      }
    />
  );
}
